//UserNav.jsx:

import { Link, useNavigate } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import React, { useState } from "react";
import "../styles/UserNav.css";
import gfglogo from "../assets/gfg_logo.png";
import { useSelector } from "react-redux";
import { logoutUserAction } from "../redux/slices/userSlices";
import { useDispatch } from "react-redux";
import Message from "./Message";
import Loader from "./Loader";

const UserNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeData = useSelector((store) => store?.users);
  const { user } = storeData;
  const logout = async () => {
    dispatch(logoutUserAction());
    localStorage.clear();
    navigate("/login");
  };

  const toggleMenu = () => {
    // console.log(isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav className="knavbar">
        <div className="logo">
          <img
            alt="logo"
            src={gfglogo}
            id="logo"
            onClick={() => {
              window.location = "/";
            }}
          />
        </div>

        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          <div className="tabs">
            <a href="/" onClick={toggleMenu}>
              <img
                alt="home"
                className="icons"
                src="https://img.icons8.com/?size=100&id=2797&format=png&color=FFFFFF"
              />
              Home
            </a>
          </div>
          <div className="tabs">
            <HashLink smooth to="/#about" onClick={toggleMenu}>
              <img
                alt="team"
                className="icons"
                src="https://img.icons8.com/?size=100&id=92274&format=png&color=FFFFFF"
              />
              About
            </HashLink>
          </div>
          <div className="tabs">
            <a href="/Questions" onClick={toggleMenu}>
              <img
                alt="Problems"
                className="icons"
                src="https://img.icons8.com/?size=100&id=26065&format=png&color=FFFFFF"
              />
              <span>Problems</span>
            </a>
          </div>
          <div className="tabs">
            <a href="/team" onClick={toggleMenu}>
              <img
                alt="team"
                className="icons"
                src="https://img.icons8.com/?size=100&id=92274&format=png&color=FFFFFF"
              />
              Team
            </a>
          </div>

          {/* <div className='tabs'>
	      <a href="/#sponsors" onClick={toggleMenu}><img alt="sponsors" className='icons' src='https://img.icons8.com/?size=100&id=ekpLghBvOGYh&format=png&color=FFFFFF' />Sponsors</a>
        </div> */}
          <div className="tabs">
            <HashLink smooth to="/#contact" onClick={toggleMenu}>
              <img
                alt="contact"
                className="icons"
                src="https://img.icons8.com/?size=100&id=yXDvI2Dfk4Lo&format=png&color=FFFFFF"
              />
              Contact
            </HashLink>
          </div>
          {user ? null : (
            <div className="tabs">
              <a href="/register" onClick={toggleMenu}>
                Register
              </a>
            </div>
          )}
        </div>

        <div id="profiletab">
          {user ? (
            <a href="/Userprofile">
              <img alt="profile" id="profile" src={user?.profilePic} />
            </a>
          ) : null}
        </div>

        <div className="menu-icon" onClick={toggleMenu}>
          <img
            alt="toogleimage"
            id="menu"
            src="https://img.icons8.com/?size=100&id=8113&format=png&color=FFFFFF"
          />
        </div>
      </nav>
      <Message />
    </>
  );
};

export default UserNav;
